module.exports = __webpack_public_path__ + "img/user-injured.326d00a6.svg";